import { useFeatureAccess } from "../../../access-control/hooks/useFeatureAccess";
import { matchesAccessGroupRule } from "../../../access-control/models/access-groups.models";
import { useAuthContext } from "../../../auth/state/AuthContext";
import { ADMIN_PATHS, ADMIN_SIDEBAR_ITEMS } from "../../models/admin.models";
import { Navigate } from "react-router-dom";

const AdminDefaultRedirect = () => {
  const { hasAnyFeature, hasFeature } = useFeatureAccess();
  const groups = useAuthContext().state.user?.accessToken?.groups ?? [];
  const firstAllowedItem = ADMIN_SIDEBAR_ITEMS.find((item) => {
    const hasRequiredGroups = !item.requiredGroups || matchesAccessGroupRule(groups, item.requiredGroups);
    const hasRequiredFeature =
      (!item.requiredFeatureKey || hasFeature(item.requiredFeatureKey)) &&
      (!item.requiredFeatureKeys?.length || hasAnyFeature(item.requiredFeatureKeys));
    const hasAdditionalAccess = item.additionalAccessRules?.some(
      (rule) => hasAnyFeature(rule.featureKeys) && matchesAccessGroupRule(groups, rule.requiredGroups),
    );

    return (hasRequiredFeature && hasRequiredGroups) || hasAdditionalAccess;
  });

  return <Navigate to={firstAllowedItem?.path ?? ADMIN_PATHS.root} replace />;
};

export default AdminDefaultRedirect;
